export const SERVER_DATE_FORMAT = 'MM/DD/YYYY';
export const APP_DATE_FORMAT = 'DD.MM.YYYY';
export const APP_DATETIME_FORMAT = 'DD.MM.YYYY hh:mm';
